import React from "react";
import "./HowToUseMyByk.scss";

import GreenArrow from "../../images/green-arrow.svg";
import Subscript from "../../images/subscription-date.svg";
import Locationhome from "../../images/location-home.svg";
import MyBykRide from "../../images/riding-bike.svg";
const HowToUseMyByk = () => {
  return (
    <section className="how-use section-padding-lg">
      <div className="how-use__header section-header">
        <h2>
          How to use <span>MYBYK</span>
        </h2>
      </div>
      <div className="container">
        <div className="how-use__content">
          <div className="how-use__content-wrap">
            <figure>
              <img src={Subscript} alt="subscription" loading="lazy" />
            </figure>
            <h3>Subscribe </h3>
            <p>
              Choose from our easily affordable plans - Daily, Weekly, Monthly
              or Pay As You Go.
            </p>
          </div>
          <div className="how-use__content-arrow">
            <figure>
              <img src={GreenArrow} alt="green-arrow" loading="lazy" />
            </figure>
          </div>
          <div className="how-use__content-wrap">
            <figure>
              <img src={Locationhome} alt="location-icon" loading="lazy" />
            </figure>
            <h3>Get your bike</h3>
            <p className="twb">
              Pick up your bike from the nearest MYBYK Hub or have it delivered
              <span>&nbsp;right at your doorstep.</span>
            </p>
          </div>
          <div className="how-use__content-arrow">
            <figure>
              <img src={GreenArrow} alt="green-arrow" loading="lazy" />
            </figure>
          </div>
          <div className="how-use__content-wrap">
            <figure>
              <img src={MyBykRide} alt="riding-my-byk" loading="lazy" />
            </figure>
            <h3>Ride it like you own it!</h3>
            <p className="twb">
              Enjoy a worry-free ride! Replace malfunctioning bikes at any MYBYK
              Hub or right at your doorstep.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowToUseMyByk;
